@import '../../../sass/colors';
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

.local-service-map {
  &__map {
    min-height: 16rem;
    aspect-ratio: 4 / 3;
  }

  &__description-term {
    height: 1.5rem;
    width: 1.5rem;

    &--area-without-local-services {
      border-color: $vtd-blue-600;
      border-width: 2px;
      border-style: solid;

      > div {
        background-color: $vtd-blue-600;
        opacity: 0.3;
      }
    }

    &--area-with-local-services {
      border-color: $vtd-blue-600;
      border-width: 2px;
      border-style: solid;

      > div {
        background-color: $vt-white;
      }
    }
  }
}
